import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-job-status-chips',
  templateUrl: './job-status-chips.component.html',
  styleUrls: ['./job-status-chips.component.scss'],
})
export class JobStatusChipsComponent implements OnChanges {
  @Input() job;

  @Input() kind = 'details';

  status: string;

  constructor(private accountService: AccountService) {}

  getBadges(job) {
    const colorFor = (b) => {
      if (b) {
        b = b.toLowerCase();
      }
      switch (b) {
        case 'cancelled':
        case 'not available':
        case 'not_available':
          return 'red-50';
        case 'closed':
        case 'expired':
        case 'not interested':
        case 'not_interested':
        case 'archived':
          return 'lilac-50';
        case 'booked':
          return 'green-50';
        case 'filled':
        case 'fulfilled':
          if (this.accountService.userIs('consumer')) {
            return 'green-50';
          }
          return 'lilac-50';
        default:
          return 'blue-50';
      }
    };
    const badges = {};

    for (const badge of job.badges[this.kind]) {
      badges[badge] = colorFor(badge);
    }
    if (job.badges.hours) {
      badges[job.badges.hours] = 'grey-100';
    }
    if (job.badges.days) {
      badges[job.badges.days] = 'grey-100';
    }

    return badges;
  }

  noSorting() {
    return 0;
  }

  colorCode() {
    if (!this.status) {
      this.status = '';
    }
    switch (this.status.toLowerCase()) {
      case 'cancelled':
      case 'not available':
      case 'rejected':
      case 'declined':
      case 'withdrew':
      case 'not_available':
        return 'red-50';
      case 'closed':
      case 'expired':
      case 'not interested':
      case 'not_interested':
      case 'archived':
        return 'lilac-50';
      case 'accepted':
      case 'filled':
      case 'fulfilled':
        return 'green-50';
      default:
        return 'blue-50';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.job?.jobKind?.isFlex && changes.job) {
      this.status = this.setStatus();
    }
  }

  /**
   * Set last minute job status display
   *
   */
  setStatus(): string {
    if (this.accountService.userIs('carer')) {
      if (!this.job?.workerFields?.allowActions?.reply && this.job?.status?.workerStatus === 'pending') {
        return this.job?.status?.clientStatusDescription;
      }
      return this.job?.status?.workerStatus;
    }
    return this.job?.status?.clientStatusDescription;
  }
}
